import { render, staticRenderFns } from "./NavigationTree.vue?vue&type=template&id=8eead8e4"
import script from "./NavigationTree.vue?vue&type=script&lang=js"
export * from "./NavigationTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavigationTree: require('/vercel/path0/components/elements/NavigationTree.vue').default})
